import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useExportScheduledMeetingsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.ISystemJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			filterRequest,
			forUserId,
			impersonationContext,
		}: {
			filterRequest: Api.IScheduledMeetingFilterRequest;
			forUserId?: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { forUserId },
					urlPath: 'ScheduledMeeting/export',
				}),
				'POST',
				filterRequest
			);
		},
		onError,
		onSuccess,
	});
};
